import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'
import patient from '../stores/patient'

const Box = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Message = styled.span`
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 200%;
`

@observer
export default class WithPatient extends Component {
  componentDidMount() {
    const { patientID } = this.props
    patient.fetch(patientID)
  }

  render() {
    const { children } = this.props

    if (patient.fetchError) {
      return (
        <Box>
          <Message><Text str="prose.couldntFetchPatient" /></Message>
        </Box>
      )
    }

    if (patient.fields) {
      return children
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/conditions/WithPatient.js